<template>
    <CenterBox
        :pageID="0"
    >
        <div id="loginPart" :style="{ 'display': $store.state.isAuthenticated ? 'none' : 'block' }">
            <h1 style="text-align: center">{{ $t("login") }}</h1>
            <form class="center-box-form " @submit.prevent="submitForm">
                <div class="center-box-form" style="text-align: left">
                    <div class="mb-3">
                        <p class="error-text" v-if="errors">{{ errors }}</p>
                        <label for="usernameInput" class="form-label">
                            {{ $t("login_username") }}
                        </label>
                        <input type="text" class="form-control" id="usernameInput" required
                               aria-describedby="licenceHelp" :placeholder='$t("login_username")'
                               v-model="usernameInput"
                        >
                    </div>
                    <div class="mb-3">
                        <label for="passwordInput" class="form-label">
                            {{ $t("login_password") }}
                        </label>
                        <input type="password" class="form-control" id="passwordInput" required
                               aria-describedby="licenceHelp" :placeholder='$t("login_password")'
                               v-model="passwordInput"
                        >
                    </div>
                    <div class="mb-3">
                        <button type="submit" class="btn btn-primary" style="width: 100%;">{{ $t("login") }}</button>
                    </div>
                    <p style="font-size: 12px"><a href="/system/licence">* {{ $t('licence_subTitle') }}</a></p>
                </div>
            </form>

            <div id="tableDiv">
                <div ref="tabulatorTableUse"></div>
                <button type="submit" class="btn btn-danger" style="width: 50%;"
                        @click="kickUser('all', 0, 0)">
                    {{ $t("login_kick_all") }}
                </button>
            </div>
        </div>
        <div id="noPermissionPart" :style="{ 'display': $store.state.isAuthenticated ? 'block' : 'none' }">
            <h3 class="error-text">Permission Denied</h3>
            <p>You don't have permission to access this page, please try other pages or contact your administrator.</p>
        </div>
    </CenterBox>

</template>

<script>
import CenterBox from "@/components/routerViewLocation/CenterBox";
import { TabulatorFull as Tabulator } from "tabulator-tables";

export default {
    name: "LoginView",
    components: {
        CenterBox,
    },
    data() {
        return {
            errors: '',
            usernameInput: '',
            passwordInput: '',
        }
    },
    methods: {
        async submitForm() {
            // clean errors
            this.errors = ""
            document.getElementById('tableDiv').style.display = 'none'

            this.$store.commit('setIsTopLoading', true)

            await this.$mainApi.post('api/client/login/', {
                "username": this.usernameInput.trim(),
                "password": this.passwordInput.trim(),
                "device": navigator.userAgent,
                "tool": this.getBrowserInfo(),
            })
                .then(response => {
                    if(response.data.status === 80) {
                        // Login Success
                        let userData = {
                            "currentOnlineListId": response.data.details.currentOnlineListId,
                            "userPermission": response.data.details.userPermission,
                            "userID": response.data.details.userID,
                            "userShowName": response.data.details.userShowName,
                        }
                        this.$store.commit('setUserLogin', userData)
                        this.$mainApi.defaults.headers.common['Accept-Language'] = this.$store.state.language;
                        this.$mainApi.defaults.headers.common['GL-User-ID'] = response.data.details.userID;
                        this.$mainApi.defaults.headers.common['GL-User-Online-ID'] = response.data.details.currentOnlineListId;

                        this.$mainApi.defaults.headers.common['GL-Page-ID'] = "1";
                        this.$mainApi.defaults.headers.common['GL-Action-ID'] = "1";

                        this.$router.push('/')

                    }else if(response.data.status === 14){
                        // Full License
                        this.errors = response.data.errors

                        document.getElementById('center-box').style.width = '97%'
                        document.getElementById('tableDiv').style.display = 'block'
                        this.tabulator.setData(response.data.details)
                        this.tabulator.redraw()
                    }else{
                        this.errors = response.data.errors
                    }
                })

            this.$store.commit('setIsTopLoading', false)
        },

        subTableIcon(cell, formatterParams){
            return "<i class='bi bi-x-circle-fill'></i>";
        },

        // kick user
        async kickUser(mode, targetUserOnlinePKID, targetUserServerID){
            const {value: text} = await this.$swal.fire({
                input: 'password',
                inputLabel: this.$t('login_btn_kick_pw'),
                inputPlaceholder: this.$t('login_btn_kick_pw'),
                inputAttributes: {
                    'aria-label': this.$t('login_btn_kick_pw')
                },
                showCancelButton: true
            })

            if(text){
                let postData = {}
                if(mode === "single"){
                    postData = {
                        "action_code": text,
                        "kick_flag": "single",
                        "kick_user_online_pk": targetUserOnlinePKID,
                        "user_id": targetUserServerID,
                        "is_action_code": "t",
                        "adminUserID": 0,
                    }
                }else if(mode === "all"){
                    postData = {
                        "action_code": text,
                        "kick_flag": "all",
                        "kick_user_online_pk": 0,
                        "user_id": 0,
                        "is_action_code": "t",
                        "adminUserID": 0,
                    }
                }
                await this.$mainApi.post('/api/client/kick/', postData)
                    .then(response => {
                        if(response.data.status === 80){
                            this.$toast.success(this.$t('common_success'))
                            this.$router.go(0)
                        }else if(response.data.status === 0){
                            this.$swal.fire({
                                title: this.$t('error_warning'),
                                html: this.$serverErrorReturn(response.data.details)
                            })
                        }else if(response.data.status === 10){
                            this.$swal.fire({
                                title: this.$t('error_warning'),
                                text: response.data.details
                            })
                        }
                    })
            }
        },

        getBrowserInfo() {
            // https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
            let nVer = navigator.appVersion;
            let nAgt = navigator.userAgent;
            let browserName = navigator.appName;
            let fullVersion = '' + parseFloat(navigator.appVersion);
            let majorVersion = parseInt(navigator.appVersion, 10);
            let nameOffset, verOffset, ix;

            // In Opera, the true version is after "Opera" or after "Version"
            if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
                browserName = "Opera";
                fullVersion = nAgt.substring(verOffset + 6);
                if ((verOffset = nAgt.indexOf("Version")) !== -1)
                    fullVersion = nAgt.substring(verOffset + 8);
            }
            // In MSIE, the true version is after "MSIE" in userAgent
            else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
                browserName = "Microsoft Internet Explorer";
                fullVersion = nAgt.substring(verOffset + 5);
            }
            // In Chrome, the true version is after "Chrome"
            else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
                browserName = "Chrome";
                fullVersion = nAgt.substring(verOffset + 7);
            }
            // In Safari, the true version is after "Safari" or after "Version"
            else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
                browserName = "Safari";
                fullVersion = nAgt.substring(verOffset + 7);
                if ((verOffset = nAgt.indexOf("Version")) !== -1)
                    fullVersion = nAgt.substring(verOffset + 8);
            }
            // In Firefox, the true version is after "Firefox"
            else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
                browserName = "Firefox";
                fullVersion = nAgt.substring(verOffset + 8);
            }
            // In most other browsers, "name/version" is at the end of userAgent
            else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
                (verOffset = nAgt.lastIndexOf('/'))) {
                browserName = nAgt.substring(nameOffset, verOffset);
                fullVersion = nAgt.substring(verOffset + 1);
                if (browserName.toLowerCase() === browserName.toUpperCase()) {
                    browserName = navigator.appName;
                }
            }
            // trim the fullVersion string at semicolon/space if present
            if ((ix = fullVersion.indexOf(";")) !== -1)
                fullVersion = fullVersion.substring(0, ix);
            if ((ix = fullVersion.indexOf(" ")) !== -1)
                fullVersion = fullVersion.substring(0, ix);

            majorVersion = parseInt('' + fullVersion, 10);
            if (isNaN(majorVersion)) {
                fullVersion = '' + parseFloat(navigator.appVersion);
                majorVersion = parseInt(navigator.appVersion, 10);
            }
            return browserName + " " + fullVersion
        },
        getHeaderMenu(){
            let menu = [];
            let columns = this.tabulator.getColumns();

            for(let column of columns){
                // If the Title has String
                if (column.getDefinition().title) {
                    //create checkbox element using font awesome icons
                    let icon = document.createElement("i");
                    icon.classList.add("bi");
                    icon.classList.add(column.isVisible() ? "bi-check-square" : "bi-square");

                    //build label
                    let label = document.createElement("span");
                    let title = document.createElement("span");

                    title.textContent = " " + column.getDefinition().title;

                    label.appendChild(icon);
                    label.appendChild(title);

                    //create menu item
                    menu.push({
                        label:label,
                        action:(e) => {
                            //prevent menu closing
                            e.stopPropagation();

                            //toggle current column visibility
                            column.toggle();

                            //change menu item icon
                            if(column.isVisible()){
                                icon.classList.remove("bi-square");
                                icon.classList.add("bi-check-square");
                            }else{
                                icon.classList.remove("bi-check-square");
                                icon.classList.add("bi-square");
                            }
                            this.tabulator.redraw()
                        }
                    });
                }
            }
            return menu;
        },
    },
    mounted() {
        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {title: 'User Nickname', field: 'user', sorter: 'string', resizable:true,
                    width:200, responsive:0,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'Login Device', field: 'device', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, minWidth: 200,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'Tool', field: 'tool', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, minWidth: 200,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'IP', field: 'ip', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 1, minWidth: 100,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'Last Active', field: 'lastActiveTime', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, minWidth: 200,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'User Server ID', field: 'user_id', visible: false},
                {title: 'User Online PK', field: 'id', visible: false},
                {formatter: this.subTableIcon,
                    headerHozAlign:"center", hozAlign:"center", vertAlign: "middle", resizable:false,
                    headerMenu: this.getHeaderMenu,
                    headerSort:false, width:10, responsive:0,
                    cellClick: (e, row, formatterParams) => {
                        this.kickUser("single", row.getData().id, row.getData().user_id)
                    }
                }
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '50vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns:true,
            movableRows: false,
            initialSort: [
                {column:"lastActiveTime", dir:"desc"},
            ],
        })
        document.getElementById('tableDiv').style.display = 'none'
    }
}
</script>

<style scoped>

</style>
